/*
* Copyright (C) GMS Inc - All Rights Reserved
* This file is part of GMSCloud. - Proprietary and confidential
* Unauthorized copying of this file, via any medium is strictly prohibited
* 
* Created on   : 30/5/2023
* @author      :Asish P Saji
* @since       : 0.0.1
* Requirement# :
* Purpose      : for adding tenant admin
* -----------------------------------------------------------------------------0
* Revision History
* -----------------------------------------------------------------------------
* Requirement/
* Issue/WorkItem |   DATE    |   AUTHOR  |   DESCRIPTION OF CHANGE
* -----------------------------------------------------------------------------
*
*
*
*/
import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { Alert, Backdrop, Button, Card, CardHeader, Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, Grid, IconButton, InputLabel, List, ListItem, MenuItem, Select, Snackbar, Switch, Typography, useMediaQuery, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { GoogleMap, useJsApiLoader, MarkerF, StandaloneSearchBox } from '@react-google-maps/api';
import { Stack } from '@mui/system';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { useOidcAccessToken } from "@axa-fr/react-oidc";
import { useLocation, useNavigate } from 'react-router-dom';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Header from '../Header';
import { tokens } from '../../hooks/theme';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs, { Dayjs } from 'dayjs';
import { createTenantAdmin, findEmailDetails, getTenantAdmin, updateTenantAdmin } from '../../services/TenantService';
import gmslogo from "../../assets/logo.gif";
import { useHandleUnauthorized } from '../../userSession/UserSession';
import { ExpandMore } from '@mui/icons-material';
import { getAllServices, getSubscriberById, updateSubscriber } from '../../services/ExternalService';
import { useState } from 'react';

const libraries: any = ['places'];

const TenantUserSetup: React.FC = () => {
    let location = useLocation()
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: "AIzaSyBHfzWHT7qgElExVxQzVRhCJtW1Z6YRILw",
        libraries
    })
    let row = location.state.tenantData;
    const [map, setMap] = React.useState(null);
    const { accessToken, accessTokenPayload } = useOidcAccessToken();
    const [role, setRole] = React.useState<any>([] as any[]);
    const [open, setOpen] = React.useState(false);
    const [count, setCount] = React.useState(0);
    const [loading, setLoading] = React.useState(false);
    const { handleUnauthorized } = useHandleUnauthorized();
    const [message, setMessage] = React.useState<any>({
        name: '',
        country: '',
        zipCode: '',
        state: '',
        address: '',
        city: '',
        birthdate: null,
        firstName: '',
        lastName: '',
        mobileNo: '',
        email: '',
        gender: '',



    });
    const [openDialogEmail, setOpenDialogEmail] = React.useState<boolean>(false);
    const [show, setShow] = React.useState(false);
    const SUPERADMIN = "superAdmin"
    const [assetData, setAssetData] = React.useState<any>({
        address: "",
        name: "",
        country: "",
        zipCode: '',
        state: "",
        city: "",
        location: "",
        status: "Active",
        birthdate: null,
        firstName: '',
        middlename: '',
        lastName: '',
        mobileNo: '',
        email: '',
        gender: '',
        tenantId: '',
        username: '',
        avatar: '',
        roles: SUPERADMIN,
        active: true


    });
    const componentData = React.useRef<any>()
    const theme = useTheme();
    const navigate = useNavigate();
    const smScreen = useMediaQuery(theme.breakpoints.up("sm"));
    const colors = tokens(theme.palette.mode);
    const [selectedFile, setSelectedFile] = React.useState<string | null>(null);
    const [image, setImage] = React.useState<any>(null);
    const [toastMessage, setToastMessage] = React.useState('');
    const [assetDataObject, setAssetDataObject] = React.useState<any>(null);
    const inputRef = React.useRef<any>();
    const [success, setSuccess] = React.useState(false);
    const [error, setError] = React.useState(false);
    const [hasData, setHasData] = React.useState(false);
    const hasEmailRef = React.useRef<boolean>(false);
    const [MobileNumberValid, setMobileNumberValid] = React.useState(true);
    const [noChange, setNoChange] = React.useState(false);
    const [successType, setSuccessType] = React.useState('');
    const [service, setService] = React.useState<any>([]);
    const [subscriber, setSubscriber] = React.useState<any>([]);
    const [subscriberChanged, setSubscriberChanged] = React.useState<boolean>(false);
    const [expanded, setExpanded] = useState(true);
    const [projectHubField, setProjectHubField] = useState<string>("");
    const [confirmationDialog, setConfirmationDialog] = React.useState<string | null>(null);
    const [pendingToggle, setPendingToggle] = useState<{ serviceId: any; serviceStatus: any } | null>(null);
    const [confirmationUpdate, setConfirmationUpdate] = React.useState(false);

    const findUserAlreadyExist = async (tenantId: any, email: any) => {
        const res = await findEmailDetails(tenantId, email, accessToken);
        hasEmailRef.current = res.data;
    };

    const handleEmailClose = () => {
        setOpenDialogEmail(false);

    };

    const onLoad = React.useCallback(function callback(map: any) {
        const bounds = new window.google.maps.LatLngBounds(componentData.current);
        map.fitBounds(bounds);
        setMap(map)
    }, [])

    const onUnmount = React.useCallback(function callback(map: any) {
        setMap(null)
    }, [])

    const onClick = (e: google.maps.MapMouseEvent) => {
        componentData.current = { lat: e.latLng?.lat(), lng: e.latLng?.lng() }
        let locationObject: any = {}
        const geocoder = new google.maps.Geocoder();
        const fulladdress: any[] = [];
        geocoder
            .geocode({ location: componentData.current })
            .then((response) => {
                if (response.results[0]) {
                    response.results[0].address_components.map((address: any) => {
                        if (address.types.includes("street_number") || address.types.includes("sublocality_level_1") || address.types.includes("sublocality_level_2") || address.types.includes("route") || address.types.includes("plus_code") || address.types.includes("landmark") || address.types.includes("premise")) {
                            fulladdress.push(address.long_name);
                            locationObject['address'] = fulladdress.join(",");
                        }
                        else if (address.types.includes("locality")) {
                            locationObject['city'] = address.long_name;
                        }
                        else if (address.types.includes("administrative_area_level_1")) {
                            locationObject['state'] = address.long_name
                        }
                        else if (address.types.includes("country")) {
                            locationObject['country'] = address.long_name
                        }
                        else if (address.types.includes("postal_code")) {
                            locationObject['zipCode'] = address.long_name
                        }
                    })
                }
                setAssetData({ ...assetData, zipCode: locationObject.zipCode, country: locationObject.country, address: locationObject.address, city: locationObject.city, state: locationObject.state, location: Object.values(componentData.current).join(",") });
            })
    }

    const getTenantAdmins = () => {
        if (row?.tenantId !== null || row?.tenantId !== '') {
            getTenantAdmin(row?.tenantId, accessToken)
                .then((res) => {
                    handleUnauthorized(res);
                    console.log(res)
                    if (res?.data !== null) {
                        let d = res?.data;
                        d['tenantId'] = row?.name;
                        d['roles'] = SUPERADMIN;
                        setAssetDataObject(d);
                        setHasData(true);
                        setSelectedFile(res?.data?.avatar)


                    }
                    setAssetData(res?.data);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }

    React.useEffect(() => {
        getTenantAdmins();
        fetchServicesData(row?.name);

        if (row.name !== null) {
            setAssetData((prevData) => ({
                ...prevData,
                tenantId: row.name,
                roles: SUPERADMIN
            }));
        } else if (row.tenantId !== null) {
            setAssetData((prevData) => ({
                ...prevData,
                tenantId: row.tenantId,
                roles: SUPERADMIN
            }));
        } else {
            setAssetData((prevData) => ({
                ...prevData,
                tenantId: row.name
            }));
        }
    }, []);

    const validateMobileNumber = (mobileNo) => {
        return /^\d{10}$/.test(mobileNo);

    };

    const allowOnlyNumbers = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (!/^[0-9]$/.test(e.key) && e.key.length === 1) {
            e.preventDefault();
        }
    };

    const inputchange = (e: any) => {
        if (e.target.name === "email") {
            setAssetData({
                ...assetData,
                username: e.target.value,
                email: e.target.value

            });
        }

        if (e.target.name === "mobileNo" || e.target.name === "alternateMobileNo") {
            if (e.target.value.length > 10) return;
        }

        if (e.target.name === "mobileNo") {
            const isValidMobileNumber = validateMobileNumber(e.target.value);
            setMobileNumberValid(isValidMobileNumber);
            setAssetData({
                ...assetData,
                mobileNo: e.target.value,


            });
        }
        else {
            setAssetData({
                ...assetData,
                [e.target.name]: e.target.value, roles: SUPERADMIN,

            });
        }
    };

    const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    const createAdmin = () => {

    }
    const validation = () => {
        let validated: any = true;
        if (assetData.displayName === '') {
            message.displayName = 'Enter Property Name';
            validated = false;

        }
        if (assetData.firstName === '') {
            message.firstName = 'Enter Your First Name';
            validated = false;

        }
        if (assetData.lastName === '') {
            message.lastName = 'Enter Your Last Name';
            validated = false;

        }
        if ((assetData.email === '') || (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(assetData.email))) {
            message.email = 'Enter Your Email';
            validated = false;

        }
        if ((assetData.mobileNo === '') || !/^\d{10}$/.test(assetData.mobileNo)) {
            message.mobileNo = 'Enter Your phone no';
            validated = false;

        }
        return validated;
    }

    const handleAlertClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        setSuccess(false);
        setError(false);
        setNoChange(false);
        navigate('/tenant')
        // onNextPage();
    }

    const handleNoChange = (event?: React.SyntheticEvent | Event, reason?: string) => {

        setNoChange(false)

    }

    const handleGoBAck = () => {
        navigate('/tenantprovision', { state: { row } });
    }

    const handleSubmit = async (e: any) => {
        let d = location.state.tenantData;
        d['tenantId'] = row?.tenantId;
        d['roles'] = SUPERADMIN;
        await findUserAlreadyExist(row?.tenantId, assetData.email);
        if (hasEmailRef.current === true) {
            setOpenDialogEmail(true);
        } else {
            setCount(count + 1);
            let formData = new FormData();
            formData.append("file", image);
            let validated = validation();
            if (validated === true) {
                setLoading(true);
                let result = await createTenantAdmin(assetData, accessToken);
                setLoading(false);
                if (result.data === true) {
                    setSuccessType('save');
                    setSuccess(true);
                }
                else {
                    setError(true);
                }
            }
            else {
                console.log(" not validated")

            }
        }
    };

    const handleDateChange = (event: Dayjs | null) => {
        setAssetData(prev => ({
            ...prev,
            birthdate: event?.isValid() ? event.format('YYYY-MM-DD') : null
        }));
    };

    const updateHandleSubmit = async () => {
        setCount(count + 1);
        let validated = validation();
        let formData = new FormData();
        formData.append("file", image);

        const profileChanged = !(
            assetDataObject.firstName === assetData.firstName &&
            assetDataObject.lastName === assetData.lastName &&
            assetDataObject.middlename === assetData.middlename &&
            assetDataObject.gender === assetData.gender &&
            assetDataObject.email === assetData.email &&
            assetDataObject.alternateMobileNo === assetData.alternateMobileNo &&
            assetDataObject.mobileNo === assetData.mobileNo &&
            assetDataObject.birthdate === assetData.birthdate &&
            assetDataObject.avatar === assetData.avatar
        );

        if (!profileChanged && !subscriberChanged) {
            setNoChange(true);
        } else if (subscriberChanged && !profileChanged) {
            setSubscriberChanged(false);
            setSuccessType('update');
            setSuccess(true);
        } else {
            if (validated === true) {
                let result = await updateTenantAdmin(assetData, accessToken);
                if (result.status === 200 || result.status === 201) {
                    setSubscriberChanged(false);
                    setSuccessType('update');
                    setSuccess(true);
                } else {
                    setError(true);
                }
            }
        }
    };

    const getFile = (event: any) => {
        const file = event.target.files[0];
        setSelectedFile(URL.createObjectURL(file));
        setImage(file);
        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                if (typeof reader.result === 'string') {
                    setAssetData({
                        ...assetData,
                        avatar: reader.result,

                    })
                }
            };
            reader.onerror = (error) => {
                console.error('Error occurred while reading the file:', error);
            };
        }
    };

    const handleCardClick = () => {
        const fileInput = document.getElementById("image-upload-input") as HTMLInputElement;
        fileInput.click();
    };

    const handlePlaceChanged = () => {
        const [place] = inputRef.current.getPlaces();
        const fulladdress: any[] = [];
        let locationObject: any = {}
        if (place) {
            place.address_components.map((address: any) => {
                if (address.types.includes("street_number") || address.types.includes("sublocality_level_1") || address.types.includes("sublocality_level_2") || address.types.includes("route") || address.types.includes("landmark") || address.types.includes("premise")) {
                    fulladdress.push(address.long_name);
                    locationObject['address'] = fulladdress.join(",");
                }
                else if (address.types.includes("locality")) {
                    locationObject['city'] = address.long_name;
                }
                else if (address.types.includes("administrative_area_level_1")) {
                    locationObject['state'] = address.long_name;
                }
                else if (address.types.includes("country")) {
                    locationObject['country'] = address.long_name;
                }
                else if (address.types.includes("postal_code")) {
                    locationObject['zipCode'] = address.long_name;
                }
                else {
                    locationObject['zipCode'] = '';
                    locationObject['address'] = fulladdress.join(",");

                }
            })

            componentData.current = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
            setAssetData({ ...assetData, zipCode: locationObject.zipCode, country: locationObject.country, address: locationObject.address, city: locationObject.city, state: locationObject.state, location: Object.values(componentData.current).join(",") });
        }
    }

    const getServiceStatus = (serviceId: any) => {
        return subscriber.filter((s: any) => s.serviceMaster === serviceId)[0]?.status;
    };

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const fetchServicesData = async (subscriberId: any) => {
        try {
            const res = await getAllServices(accessToken);
            setService(res.data);
            const response = await getSubscriberById(accessToken, subscriberId);
            if (response.data && Array.isArray(response.data) && response.data.length > 0) {
                setSubscriber(response?.data);
            } else {
                console.warn('Subscriber data is empty or invalid');
            }
        } catch (error) {
            console.error('Error fetching subscriber data:', error);
        }
    };

    const handleToggle = async (item: any) => {
        let serviceStatus: any = getServiceStatus(item.id);
        serviceStatus = serviceStatus === undefined
            ? item.status === "Active" ? "InActive" : "Active"
            : serviceStatus;
        if (serviceStatus === "Active") {
            setConfirmationDialog("Are you sure you want to disable this service to this Tenant?");
            setPendingToggle({ serviceId: item.id, serviceStatus });
            setConfirmationUpdate(true);
        } else {
            proceedToggle(item.id, serviceStatus);
        }
    };

    const proceedToggle = async (serviceId: any, currentStatus: any) => {
        const newStatus = currentStatus === "Active" ? "InActive" : "Active";
        const updatedSubscriber = subscriber.map((s: any) =>
            s.serviceMaster === serviceId ? { ...s, status: newStatus } : s
        );
        setSubscriber(updatedSubscriber);
        const param = {
            serviceMaster: serviceId,
            status: newStatus,
            createdBy: accessTokenPayload.oid,
            subscriberType: "Tenant",
            subscriberId: row?.name,
            invalid: false,
            additionalInfo: projectHubField || ''
        };
        try {
            await updateSubscriber(param, accessToken);
            setSubscriberChanged(true);
            fetchServicesData(row?.name);
        } catch (error) {
            console.error("Error updating service status:", error);
        }
    };

    const handleConfirm = () => {
        if (pendingToggle) {
            proceedToggle(pendingToggle.serviceId, pendingToggle.serviceStatus);
            setPendingToggle(null);
        }
        setConfirmationUpdate(false);
    };

    const handleCloseDialog = () => {
        setPendingToggle(null);
        setConfirmationUpdate(false);
    };

    const isSuccessMessage = toastMessage === 'Inserted Successfully' || toastMessage === 'Updated Successfully';


    return (
        <>
            <Grid container justifyContent="center" alignItems="center" >
                <Grid item xs={12} sm={12}>
                    <Box
                        display={smScreen ? "flex" : "block"}
                        flexDirection={smScreen ? "row" : "column"}
                        alignItems={smScreen ? "center" : "start"}
                        m="1px 0"
                    >
                        <Grid item sm={6}>
                            {assetDataObject ? <Header title="Edit Tenant User" subtitle={""} /> : <Header title="Create Tenant User" subtitle={""} />}
                        </Grid>
                        <Grid item sm={6} sx={{ display: 'flex', justifyContent: 'flex-end', gap: '15px' }}>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>


            {/* </Stack> */}


            <Snackbar open={open} autoHideDuration={1000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} sx={{ paddingTop: 6 }}>
                <Alert onClose={handleClose} severity={isSuccessMessage ? 'success' : 'warning'} sx={{ width: '100%' }} >
                    {toastMessage}
                </Alert>
            </Snackbar>
            <Grid container justifyContent="center" alignItems="center" rowSpacing={2} columnSpacing={{ xs: 4, sm: 2, md: 3 }}>
                <Grid item xs={12} sm={12}>
                    <Box>
                        <Card className='POCard' variant="outlined" sx={{ p: 3, maxWidth: "1500px" }} >
                            <Grid container spacing={2} columns={13} className='tenantCard'>
                                <Grid item xs={13} sm={13} md={3} lg={3} xl={3}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} className={loading ? 'blur-background' : ''}>
                                            <Backdrop open={loading} style={{ zIndex: 9999 }}>
                                                {/* <CircularProgress color="inherit" /> */}
                                                <Grid container alignItems="center" justifyContent="center">
                                                    <Grid item md={12} style={{ textAlign: 'center' }}>
                                                        <img src={gmslogo} alt="Image" className="topBarLogo" />
                                                    </Grid>
                                                    <Grid item md={12} style={{ textAlign: 'center' }}>

                                                        <Typography className="loading" variant='h4' color="blue">Please wait...</Typography>

                                                    </Grid>
                                                </Grid>
                                            </Backdrop>

                                            <Card variant="outlined" className='tenantImageUpload'
                                                onClick={handleCardClick}
                                            >
                                                <label>
                                                    {selectedFile ? (
                                                        <img src={selectedFile} alt="Uploaded Logo" className="tenantImageUpload" />
                                                        ) : (
                                                        <Stack sx={{ textAlign: "center", cursor: "pointer" }}>
                                                            <Typography>
                                                            <AddIcon />
                                                            </Typography>
                                                            <Typography>Click to upload profile picture</Typography>
                                                        </Stack>
                                                    )}
                                                </label>
                                                <input
                                                    type="file"
                                                    id="image-upload-input"
                                                    onChange={(e) => getFile(e)}
                                                    style={{ display: "none" }}
                                                    accept="image/*"
                                                />
                                            </Card>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}> <Typography className='assetSubHeader' fontSize={20} sx={{ color: colors.greenAccent[1000] }}>Enter Tenant Administrator's Information</Typography></Grid>

                                        <Grid item xs={4}>
                                            <TextField
                                                error={(assetData.firstName === '' && count !== 0)}
                                                id="demo-helper-text-aligned"
                                                label="First Name"
                                                name="firstName"
                                                size="small"
                                                fullWidth
                                                required
                                                value={assetData.firstName}
                                                helperText={(assetData.firstName === '' && count !== 0) ? message.firstName : null}
                                                onChange={(e) => inputchange(e)}
                                            /></Grid>
                                        <Grid item xs={4}>
                                            <TextField
                                                error={(assetData.middleName === '' && count !== 0)}
                                                id="demo-helper-text-aligned"
                                                label="Middle Name"
                                                name="middleName"
                                                size="small"
                                                fullWidth
                                                value={assetData.middleName}
                                                helperText={(assetData.middleName === '' && count !== 0) ? message.middleName : null}
                                                onChange={(e) => inputchange(e)}
                                            /></Grid>
                                        <Grid item xs={4}>
                                            <TextField
                                                error={(assetData.lastName === '' && count !== 0)}
                                                id="demo-helper-text-aligned"
                                                label="Last Name"
                                                name="lastName"
                                                size="small"
                                                fullWidth
                                                required
                                                value={assetData.lastName}
                                                helperText={(assetData.lastName === '' && count !== 0) ? message.lastName : null}
                                                onChange={(e) => inputchange(e)}
                                            /></Grid>
                                        {/* <Grid item xs={6}> */}
                                        <Grid item xs={12} md={6}>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DemoContainer components={['DatePicker']}>
                                                    <DatePicker
                                                        label="Birth Date"
                                                        name='birthdate'
                                                        onChange={(e: Dayjs | null) => handleDateChange(e)}
                                                        value={assetData?.birthdate ? dayjs(assetData.birthdate) : null}
                                                        slotProps={{
                                                            textField: {
                                                                fullWidth: true,
                                                                size: 'small',
                                                            }
                                                        }}
                                                    />
                                                </DemoContainer>
                                            </LocalizationProvider>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label" >
                                                    Gender
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={assetData?.gender || ''}
                                                    label="Gender"
                                                    name="gender"
                                                    onChange={(e: any) => inputchange(e)}
                                                    size='small'
                                                >
                                                    <MenuItem value={"male"}>Male </MenuItem>
                                                    <MenuItem value={"female"}>Female</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={6}>
                                            <TextField
                                                error={(!MobileNumberValid && count !== 0) || (assetData.mobileNo === '' && count !== 0)}
                                                helperText={!MobileNumberValid ? "Invalid mobile number" : null}
                                                id="demo-helper-text-aligned"
                                                label="Mobile No"
                                                name="mobileNo"
                                                size="small"
                                                fullWidth
                                                required
                                                value={assetData.mobileNo}
                                                onChange={(e) => inputchange(e)}
                                                inputProps={{
                                                    maxLength: 10,
                                                }}
                                                onKeyDown={allowOnlyNumbers}
                                            /></Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                id="demo-helper-text-aligned"
                                                label="Secondary Mobile No"
                                                name="alternateMobileNo"
                                                size="small"
                                                fullWidth
                                                value={assetData.alternateMobileNo || ''}
                                                helperText={(assetData.alternateMobileNo === '' && count !== 0) ? message.alternateMobileNo : null}
                                                onChange={(e) => inputchange(e)}
                                                onKeyDown={allowOnlyNumbers}
                                            /></Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                error={(assetData.email === '' && count !== 0) || (count !== 0 && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(assetData.email))}
                                                id="demo-helper-text-aligned"
                                                label="Email"
                                                name="email"
                                                size="small"
                                                fullWidth
                                                required
                                                value={assetData.email}
                                                disabled={
                                                    assetDataObject &&
                                                    assetDataObject.email !== null &&
                                                    assetDataObject.email !== undefined &&
                                                    assetDataObject.email !== ''
                                                }
                                                helperText={
                                                    assetData.email === '' && count !== 0
                                                        ? message.email
                                                        : !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(assetData.email)
                                                            ? 'Please enter a valid email address'
                                                            : null}
                                                onChange={(e) => inputchange(e)}
                                            /></Grid>

                                        {/* <Grid item xs={6}>
                                        <TextField
                                                error={(assetData.displayName === '' && count !== 0)}
                                                id="demo-helper-text-aligned"
                                                label="Display Name"
                                                name="displayName"
                                                size="small"
                                                fullWidth
                                                required
                                                value={assetData.displayName}
                                                // value={assetDataObject ? assetDataObject.propertyName : assetData.propertyName}
                                                // required
                                                helperText={(assetData.displayName === '' && count !== 0) ? message.displayName : null}
                                                onChange={(e) => inputchange(e)}
                                            /></Grid> */}
                                        {/*       <Grid item xs={6}>
                                            {isLoaded
                                                &&
                                                <StandaloneSearchBox
                                                    onLoad={ref => inputRef.current = ref}
                                                    onPlacesChanged={handlePlaceChanged}
                                                >
                                                    <TextField
                                                        error={(assetData.address === '' && count !== 0)}
                                                        id="Street address"
                                                        label="Street address"
                                                        name="address"
                                                        size="small"
                                                        fullWidth
                                                        value={assetData.address}
                                                        // value={assetDataObject ? assetDataObject.address : assetData.address}
                                                        required
                                                        helperText={(assetData.address === '' && count !== 0) ? message.address : null}
                                                        // helperText={message.address}
                                                        onChange={(e) => inputchange(e)}
                                                    />
                                                </StandaloneSearchBox>}
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                error={(assetData.city === '' && count !== 0)}
                                                id="demo-helper-text-aligned"
                                                label="City"
                                                size="small"
                                                fullWidth
                                                required
                                                name="city"
                                                value={assetData.city}
                                                // value={assetDataObject ? assetDataObject.city : assetData.city}
                                                helperText={(assetData.city === '' && count !== 0) ? message.city : null}
                                                onChange={(e) => inputchange(e)}

                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                error={(assetData.state === '' && count !== 0)}
                                                id="demo-helper-text-aligned-no-helper"
                                                label="State"
                                                size="small"
                                                fullWidth
                                                name="state"
                                                required
                                                value={assetData.state}
                                                // value={assetDataObject ? assetDataObject.state : assetData.state}
                                                onChange={(e) => inputchange(e)}
                                                helperText={(assetData.state === '' && count !== 0) ? message.state : null}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                error={(assetData.country === '' && count !== 0)}
                                                id="demo-helper-text-aligned-no-helper"
                                                label="Country"
                                                size="small"
                                                fullWidth
                                                value={assetData.country}
                                                // value={assetDataObject ? assetDataObject.country : assetData.country}
                                                helperText={(assetData.country === '' && count !== 0) ? message.country : null}
                                                name="country"
                                                required
                                                onChange={(e) => inputchange(e)}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                error={(assetData.zipCode === '' && count !== 0)}
                                                id="demo-helper-text-aligned-no-helper"
                                                label="Zip Code"
                                                size="small"
                                                name="zipCode"
                                                fullWidth
                                                value={assetData.zipCode}
                                                // value={assetDataObject ? assetDataObject.zipCode : assetData.zipCode}
                                                required
                                                helperText={(assetData.zipCode === '' && count !== 0) ? message.zipCode : null}
                                                onChange={(e) => inputchange(e)}
                                            />
                                        </Grid>

                                        {/* <Grid item xs={6}>
                                            <TextField
                                                error={(assetData.stories === null && count !== 0)}
                                                id="demo-helper-text-aligned-no-helper"
                                                label="Number of stories"
                                                size="small"
                                                fullWidth
                                                name="stories"
                                                type='number'
                                                // required
                                                helperText={(assetData.stories === '' && count !== 0) ? message.stories : null}
                                                // value={assetDataObject ? assetDataObject.stories : assetData.stories}
                                                value={assetData.stories}
                                                onChange={(e) => inputchange(e)}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                error={(assetData.area === null && count !== 0)}
                                                id="demo-helper-text-aligned-no-helper"
                                                label="Area in sq"
                                                size="small"
                                                fullWidth
                                                name="area"
                                                type='number'
                                                // required
                                                helperText={(assetData.area === '' && count !== 0) ? message.area : null}
                                                // value={assetDataObject ? assetDataObject.stories : assetData.stories}
                                                value={assetData.area}
                                                onChange={(e) => inputchange(e)}
                                            />
                                        </Grid> */}
                                        {/* <Grid item xs={6}>

                                            <Typography>Is this asset your Billing Address?</Typography>
                                            <FormControlLabel
                                                value="end"
                                                control={<Checkbox size='small' />}
                                                label="Yes"
                                                labelPlacement="end"
                                            />

                                        </Grid> */}
                                    </Grid>
                                </Grid>
                            </Grid>
                            {/*      <Grid container spacing={1} sx={{ marginTop: 1 }}>
                                <Grid item xs={12}>
                                    <Stack direction={'row'}>
                                        <Typography><MapOutlinedIcon fontSize='small' /></Typography>
                                        <Typography>Choose from MAP</Typography>
                                    </Stack>
                                </Grid>
                                <Grid item xs={13}>
                                    {isLoaded ? (

                                        <GoogleMap
                                            mapContainerStyle={containerStyle}
                                            center={componentData.current}
                                            zoom={10}
                                            onLoad={onLoad}
                                            onUnmount={onUnmount}
                                            onClick={onClick}
                                        >
                                            <MarkerF
                                                position={componentData.current}
                                            >
                                            </MarkerF>

                                            <></>

                                        </GoogleMap>
                                    ) : <></>}
                                </Grid>
                            </Grid>
*/}
                            <Grid sx={{ mt: '2vh' }}>
                                <Card sx={{ p: 2 }}>
                                    <CardHeader
                                        title="3rd Party Services"
                                        sx={{ backgroundColor: '#E3E8FE' }}
                                        action={
                                            <IconButton
                                                onClick={handleExpandClick}
                                                aria-expanded={expanded}
                                                aria-label="show more"
                                            >
                                                <ExpandMore />
                                            </IconButton>
                                        }
                                    />
                                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                                        <List>
                                            {service.map((item: any) => {
                                                if (item.status !== "Active") return null;
                                                if (item.name === "Killbill") return null;
                                                if (item.name === "ProjectHub") {
                                                    return (
                                                        <ListItem key={item?.id} sx={{ display: 'flex', alignItems: 'center' }}>
                                                            <Grid item xs={2}>
                                                                <Typography variant="h5" sx={{ fontSize: '15px' }}>
                                                                    {item.name}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid sx={{ display: "flex", alignItems: "center", gap: 2 }} xs={1}>
                                                                {(() => {
                                                                    const subIdx = subscriber.findIndex((s: any) => s.serviceMaster === item.id);
                                                                    const sub = subscriber[subIdx] || {};
                                                                    const isActive = sub.status === "Active";
                                                                    const hasAdditionalInfo = !!sub.additionalInfo;
                                                                    const switchDisabled = isActive ? false : !(projectHubField || hasAdditionalInfo);
                                                                    return (
                                                                        <Switch
                                                                            checked={isActive}
                                                                            onChange={() => handleToggle(item)}
                                                                            color="primary"
                                                                            sx={{ transform: "scale(1.8)" }}
                                                                            disabled={switchDisabled}
                                                                        />
                                                                    );
                                                                })()}
                                                            </Grid>
                                                            <Grid item xs={9}>
                                                                {(() => {
                                                                    const subIdx = subscriber.findIndex((s: any) => s.serviceMaster === item.id);
                                                                    const sub = subscriber[subIdx] || {};
                                                                    const hasAdditionalInfo = !!sub.additionalInfo;
                                                                    return (
                                                                        <TextField
                                                                            size="small"
                                                                            placeholder="Enter ProjectHub Server Url"
                                                                            value={projectHubField || sub.additionalInfo || ''}
                                                                            onChange={e => setProjectHubField(e.target.value)}
                                                                            fullWidth
                                                                            InputProps={{ readOnly: hasAdditionalInfo }}
                                                                        />
                                                                    );
                                                                })()}
                                                            </Grid>
                                                        </ListItem>
                                                    );
                                                }
                                                return (
                                                    <ListItem key={item?.id} sx={{ display: 'flex', alignItems: 'center' }}>
                                                        <Grid item xs={2}>
                                                            <Typography variant="h5" sx={{ fontSize: '15px' }}>
                                                                {item.name}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid sx={{ display: "flex", justifyContent: "flex-start" }}>
                                                            <Switch
                                                                checked={subscriber[subscriber.findIndex((s: any) => s.serviceMaster === item.id)]?.status === "Active"}
                                                                onChange={() => handleToggle(item)}
                                                                color="primary"
                                                                sx={{ transform: "scale(1.8)" }}
                                                            />
                                                        </Grid>
                                                    </ListItem>
                                                );
                                            })}
                                        </List>
                                    </Collapse>
                                </Card>
                            </Grid>
                            <Grid container spacing={2} justifyContent="flex-end" mt={2}>
                                <Grid item mt={1}>
                                    {hasData ? (
                                        <Button className='successButton' variant="contained" size="medium" onClick={updateHandleSubmit}>
                                            Update
                                        </Button>
                                    ) : (
                                        <Button className='successButton' variant="contained" size="medium" onClick={handleSubmit}>
                                            Submit
                                        </Button>
                                    )}
                                </Grid>

                                {/* )} */}
                                <Grid item>
                                    <Button className='dangerButton' variant="contained" size="medium" onClick={handleGoBAck} >
                                        Go Back
                                    </Button>
                                </Grid>
                            </Grid>
                        </Card>
                    </Box>
                    <Dialog open={success} >
                        <DialogTitle className='success'>
                            <Box paddingLeft={8} paddingRight={8}>
                                <Typography textAlign={'center'}>
                                    <CheckCircleOutlinedIcon sx={{ fontSize: "50px", color: "white" }} /></Typography>
                                <Typography textAlign={'center'} color='white' fontSize={'20px'} fontWeight={'400'} >
                                    Success
                                </Typography>
                            </Box>
                        </DialogTitle>
                        <Box paddingLeft={8} paddingRight={8}>
                            <DialogContent >
                                <DialogContentText textAlign={'center'} fontSize={'18px'} fontWeight={'500'}> {successType === 'save' ? 'Tenant User created successfully.' : 'Tenant User updated successfully.'}</DialogContentText>
                            </DialogContent>
                            <DialogActions style={{ justifyContent: "center" }}>
                                <Button variant='contained' className="successButton" onClick={handleAlertClose}>Ok</Button>
                            </DialogActions>
                        </Box>
                    </Dialog>

                    <Dialog open={error} >
                        <DialogTitle className='error'>
                            <Box paddingLeft={8} paddingRight={8}>
                                <Typography textAlign={'center'}>
                                    <CancelOutlinedIcon sx={{ fontSize: "50px", color: "white" }} /></Typography>
                                <Typography textAlign={'center'} color='white' fontSize={'20px'} fontWeight={'400'} >
                                    Error
                                </Typography>
                            </Box>
                        </DialogTitle>
                        <Box paddingLeft={8} paddingRight={8}>
                            <DialogContent >
                                <DialogContentText textAlign={'center'} fontSize={'18px'} fontWeight={'500'}>{successType === 'save' ? 'Failed to create Tenant User. Please try again or contact support if the issue persists.' 
                                : 'Failed to update Tenant User. Please try again or contact support if the issue persists.'}</DialogContentText>
                            </DialogContent>
                            <DialogActions style={{ justifyContent: "center" }}>
                                <Button variant='contained' sx={{ backgroundColor: "#df3333ed" }} onClick={handleAlertClose}>Close</Button>
                            </DialogActions>
                        </Box>

                    </Dialog>
                    <Dialog open={openDialogEmail} >
                        <DialogTitle className='warning'>
                            <Box paddingLeft={8} paddingRight={8}>
                                <Typography textAlign={'center'}>
                                    <PriorityHighIcon sx={{ fontSize: "50px", color: "white" }} />
                                </Typography>
                                <Typography textAlign={'center'} color='white' fontSize={'20px'} fontWeight={'400'} >
                                    Warning
                                </Typography>
                            </Box>
                        </DialogTitle>
                        <Box paddingLeft={8} paddingRight={8}>
                            <DialogContent>
                                <DialogContentText textAlign={'center'} fontSize={'18px'} fontWeight={'500'}>
                                    Email already registered
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions style={{ justifyContent: "center" }}>
                                <Button variant='contained' className='warning' onClick={handleEmailClose}>Close</Button>
                            </DialogActions>
                        </Box>
                    </Dialog>

                    <Dialog open={noChange} >
                        <DialogTitle className='success' sx={{ backgroundColor: "rgb(255,193,0) !important" }}>
                            <Box paddingLeft={8} paddingRight={8}>
                                <Typography textAlign={'center'}>
                                    <InfoOutlinedIcon sx={{ fontSize: "50px", color: "white" }} /></Typography>
                                {/* <Typography textAlign={'center'} color='white' fontSize={'20px'} fontWeight={'400'} >
                               Success
                            </Typography> */}
                            </Box>
                        </DialogTitle>
                        <Box paddingLeft={8} paddingRight={8}>
                            <DialogContent >
                                <DialogContentText textAlign={'center'} fontSize={'18px'} fontWeight={'500'}>No value has been changed.</DialogContentText>
                            </DialogContent>
                            <DialogActions style={{ justifyContent: "center" }}>
                                <Button variant='contained' className="NoChangeButton" onClick={handleNoChange}>Ok</Button>
                            </DialogActions>
                        </Box>
                    </Dialog>
                    <Dialog open={confirmationUpdate}>
                        <DialogTitle
                            className="success"
                            sx={{ backgroundColor: "rgb(255,193,0) !important" }}
                        >
                            <Box paddingLeft={8} paddingRight={8}>
                                <Typography textAlign={"center"}>
                                    <InfoOutlinedIcon sx={{ fontSize: "50px", color: "white" }} />
                                </Typography>
                            </Box>
                        </DialogTitle>
                        <Box paddingLeft={8} paddingRight={8}>
                            <DialogContent>
                                <DialogContentText
                                    textAlign={"center"}
                                    fontSize={"18px"}
                                    fontWeight={"500"}
                                >
                                    {confirmationDialog}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions style={{ justifyContent: "center" }}>
                                <Button
                                    variant="contained"
                                    className="NoChangeButton"
                                    onClick={handleConfirm}
                                >
                                    confirm
                                </Button>
                                <Button
                                    variant="contained"
                                    className="NoChangeButton"
                                    onClick={handleCloseDialog}
                                >
                                    Close
                                </Button>
                            </DialogActions>
                        </Box>
                    </Dialog>                
                </Grid>
            </Grid>

        </>
    );
}

export default TenantUserSetup;